export default __webpack_public_path__ + "static/media/lt-logo-green.2e351564.svg";